import { render, staticRenderFns } from "./NextTermSummary.vue?vue&type=template&id=a01a8c8c&scoped=true&"
import script from "./NextTermSummary.vue?vue&type=script&lang=js&"
export * from "./NextTermSummary.vue?vue&type=script&lang=js&"
import style0 from "./NextTermSummary.vue?vue&type=style&index=0&id=a01a8c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01a8c8c",
  null
  
)

export default component.exports